import React, { useState } from 'react';
import Header from '../utils/Header'
import Footer from '../utils/Footer'
import Check from '../../assets/Check.png'

const Rent = () => {

  return (
    <div >
      <Header />
      <div className="p-6 bg-white rounded-lg shadow-md max-w-2xl mx-auto mt-8 text-primaryP font-poppins">
        <h2 className="text-2xl font-semibold text-center mb-4 text-primaryP">Maximiza el valor de tu propiedad con LetoH</h2>
        <p className="text-gray-700 mb-4">
          En LetoH, transformamos tu inmueble en una inversión segura y rentable. Con nuestro modelo de renta garantizada, aseguramos ingresos fijos sin importar la ocupación, eliminando la incertidumbre y la gestión compleja de alquileres.
        </p>
        <p className="text-gray-700 mb-4 font-semibold ">Al confiar en nosotros, obtienes:</p>
        <ul className="space-y-4">
          <li className="flex items-center">
            <img src={Check} alt="Check" className="w-6 h-6 mr-2" />
            <span>Ingresos asegurados mes a mes</span>
          </li>
          <li className="flex items-center">
            <img src={Check} alt="Check" className="w-6 h-6 mr-2" />
            <span>Gestión profesional sin preocupaciones</span>
          </li>
          <li className="flex items-center">
            <img src={Check} alt="Check" className="w-6 h-6 mr-2" />
            <span>Maximización del valor de tu propiedad</span>
          </li>
        </ul>
        <p className="text-gray-700 mt-4">
          Con LetoH, rentabilizar tu inmueble nunca ha sido tan fácil y seguro. Únete y disfruta de los beneficios de una plataforma que trabaja para ti.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Rent;


